import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PaymentReversalReducer } from "../reducers";

export const selectPaymentReversalFeature = createFeatureSelector<PaymentReversalReducer.PaymentReversalState>(PaymentReversalReducer.featureName);

export const selectPaymentReversal = createSelector(selectPaymentReversalFeature, (state: PaymentReversalReducer.PaymentReversalState) => state.item);
